import { containsNonAsciiCharacters } from '@/utils/containsNonAsciiCharacters';

export const validateEmail = (email: string) => {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email.trim()) && !containsNonAsciiCharacters(email);
};
